module.exports = __webpack_public_path__ + "img/A9.78b4e802.png";